export interface PackageInfo {
  id: string;
  name: string;
  price: string;
  credits: number;
  perCredit: string;
  popular?: boolean;
  hidden?: boolean;
  features: string[];
}

const ALL_PACKAGES: PackageInfo[] = [
  {
    id: "starter",
    name: "Hobby",
    price: "$50",
    credits: 360,
    perCredit: "$0.14",
    features: ["Watermark-free creations", "All video & image styles", "480p video quality", "Instant delivery", "Tokens never expire"],
  },
  {
    id: "creator",
    name: "Creator",
    price: "$100",
    credits: 1100,
    perCredit: "$0.09",
    popular: true,
    features: ["Watermark-free creations", "3.1x more tokens", "720p HD video quality", "Priority rendering", "Tokens never expire"],
  },
  {
    id: "pro",
    name: "Studio",
    price: "$200",
    credits: 2500,
    perCredit: "$0.08",
    features: ["Watermark-free creations", "6.9x more tokens", "720p HD video quality", "Bulk creation power", "Tokens never expire"],
  },
  {
    id: "studio",
    name: "Agency",
    price: "$400",
    credits: 6000,
    perCredit: "$0.07",
    hidden: true,
    features: ["Watermark-free creations", "All video & image styles", "720p HD video quality", "Priority rendering", "Bulk creation tools", "Dedicated support"],
  },
];

export const CREDIT_PACKAGES = ALL_PACKAGES.filter((p) => !p.hidden);
